import { AppRestClient } from "@/util/rest/clients/app-rest-client";

import { BizUserRecentPositionsModels } from "./bizUserRecentPositions.models";

export namespace BizUserRecentPositionsApi {
  export const getRecentPositions = () => {
    return AppRestClient.get(
      { resSchema: BizUserRecentPositionsModels.BizRecentPositionResponseDtoSchema },
      `/biz/recent-positions`,
    );
  };

  export const addRecentPosition = (data: BizUserRecentPositionsModels.AddRecentPositionDto) => {
    return AppRestClient.post(
      { resSchema: BizUserRecentPositionsModels.BizRecentPositionResponseDtoSchema },
      `/biz/recent-positions`,
      data,
    );
  };
}
